import { RmsPulldownService } from '../../services/rms-pulldown.service';
import { NavigationFavoritesService } from '../../services/navigation-favorites.service';
import { NavTabService } from '../../services/nav-tab.service';
import { Component, OnDestroy, TemplateRef, Type, ViewChild } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { Subscription } from 'rxjs';
import { RmsModule } from '../../custom-modules/rms-module/rms.module';
import { UserPreferenceService } from '../../services/user-preference.service';
import { QuickLinkService } from '../../services/quick-links.service';

@Component({
  selector: 'app-quick-links',
  imports: [MatMenuModule, MatDialogModule, RmsModule, MatButtonModule],
  templateUrl: './quick-links.component.html',
  styleUrl: './quick-links.component.scss'
})
export class QuickLinksComponent implements OnDestroy {
  @ViewChild('actionPanel') actionPanel!: TemplateRef<unknown>;
  selectedComponent: Type<any> | null = null;
  selectedLabel = '';
  readonly userQuickLinks;
  private dialogRef?: MatDialogRef<unknown>;
  private readonly closeSubscription: Subscription;

  constructor(public favorites:NavigationFavoritesService, public tabs:NavTabService, userPref: UserPreferenceService, quickLinkService: QuickLinkService, private dialog: MatDialog, private pulldown: RmsPulldownService) {
    this.userQuickLinks = userPref.getUserQuickLinks();
    this.closeSubscription = quickLinkService.onClose$.subscribe(() => this.closeQuickLink());
  }

  selectComponent(link: { component: Type<any>; label: string; pulldown?: boolean }) {
    if (link.pulldown) {
      this.pulldown.open(link.component, {
        data: {}, title: link.label, width: '85vw', maxWidth: '95vw',
        top: '0', maxHeight: '92vh', minHeight: '70vh'
      });
      return;
    }
    this.selectedComponent = link.component;
    this.selectedLabel = link.label;
    this.dialogRef = this.dialog.open(this.actionPanel, {
      width: '460px', maxWidth: 'calc(100vw - 32px)', maxHeight: 'calc(100dvh - 32px)',
      ariaLabel: link.label, autoFocus: 'first-tabbable', restoreFocus: true
    });
    this.dialogRef.afterClosed().subscribe(() => {
      this.selectedComponent = null;
      this.dialogRef = undefined;
    });
  }

  closeQuickLink() { this.dialogRef?.close(); }

  ngOnDestroy() {
    this.closeSubscription.unsubscribe();
    this.closeQuickLink();
  }
}
